import Swal from "sweetalert2";

const BASE_URL = process.env.REACT_APP_RSF_API_URL;
const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME;
const FY_HEADER = localStorage.getItem("x-FY");

// Set default headers
const defaultHeaders = {
  "Content-Type": "application/json",
  ...(FY_HEADER && { "x-FY": FY_HEADER }),
};

// Function to set the token in headers
let authToken = null;
if (localStorage.getItem(TOKEN_NAME)) {
  setToken(localStorage.getItem(TOKEN_NAME));
}

function setToken(token) {
  authToken = token;
}

// Helper function to handle responses
async function handleResponse(response) {
  if (!response.ok) {
    if (response.status === 500) {
      Swal.fire({
        icon: "error",
        title: `500 Internal Server Error

        Sorry, we encountered an unexpected error while processing your request. Please try again later.`,
        showConfirmButton: false,
      });
    }
    const error = await response.json();
    return Promise.reject(error);
  }
  return response.json();
}

// Helper function to make requests
async function request(method, url, data = null, headers = {}) {
  const options = {
    method,
    headers: {
      ...defaultHeaders,
      ...(authToken && { "x-auth-token": authToken }),
      ...headers,
    },
    ...(data && { body: JSON.stringify(data) }),
  };

  const response = await fetch(`${BASE_URL}${url}`, options);
  return handleResponse(response);
}

// Exported functions for HTTP methods
const fetchAPI = {
  get: (url, headers = {}) => request("GET", url, null, headers),
  post: (url, data, headers = {}) => request("POST", url, data, headers),
  put: (url, data, headers = {}) => request("PUT", url, data, headers),
  delete: (url, headers = {}) => request("DELETE", url, null, headers),
  setToken,
};

export default fetchAPI;
